/**
 * Shopify竖屏视频轮播 - 移动端滚动修复版
 */

(function() {
  'use strict';
  
  console.log('🎬 视频轮播加载中...');
  
  // ========== 主函数 ==========
  function initVideoCarousel() {
    const container = document.querySelector('.carousel-container');
    if (!container) {
      console.error('❌ 找不到轮播容器');
      return;
    }
    
    console.log('✅ 找到轮播容器');
    
    // 关键元素
    const track = container.querySelector('.cover-track');
    const slides = Array.from(container.querySelectorAll('.cover-slide'));
    const leftArrow = container.querySelector('.left-arrow');
    const rightArrow = container.querySelector('.right-arrow');
    
    if (!track || slides.length === 0) {
      console.error('❌ 找不到封面或轨道');
      return;
    }
    
    console.log(`✅ 找到 ${slides.length} 个视频封面`);
    
    // 状态变量
    let isPaused = false;
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;
    let animationId = null;
    let autoScrollSpeed = 1.2;
    let slideWidth = 0;
    let cloneCount = 0;
    let totalSlides = slides.length;
    let allSlides = [];
    
    // ========== 1. 初始化无缝循环滚动 - 修复移动端问题 ==========
    function initSeamlessScroll() {
      // 清除旧克隆
      const oldClones = track.querySelectorAll('.slide-clone');
      oldClones.forEach(clone => clone.remove());
      
      // 获取计算样式
      const trackStyle = window.getComputedStyle(track);
      const gap = parseInt(trackStyle.gap) || 10; // 获取gap值，默认10px
      
      // 计算幻灯片宽度（包括间隙）
      const firstSlide = slides[0];
      if (!firstSlide) return;
      
      // 获取幻灯片的实际宽度
      slideWidth = firstSlide.offsetWidth + gap;
      console.log(`📏 幻灯片宽度: ${slideWidth}px (元素: ${firstSlide.offsetWidth}px + 间隙: ${gap}px)`);
      
      // 计算每屏显示的幻灯片数量
      const containerWidth = container.clientWidth;
      const slidesPerView = Math.max(1, Math.floor(containerWidth / slideWidth));
      
      console.log(`📐 每屏显示 ${slidesPerView} 个幻灯片，容器宽度: ${containerWidth}px`);
      
      // 只在幻灯片数量大于可视数量时才需要克隆
      cloneCount = slidesPerView;
      
      // 在末尾添加开头的几个克隆
      for (let i = 0; i < cloneCount; i++) {
        const clone = slides[i % totalSlides].cloneNode(true);
        clone.classList.add('slide-clone');
        track.appendChild(clone);
      }
      
      // 在开头添加末尾的几个克隆
      for (let i = 0; i < cloneCount; i++) {
        const clone = slides[(totalSlides - 1 - i) % totalSlides].cloneNode(true);
        clone.classList.add('slide-clone');
        track.insertBefore(clone, track.firstChild);
      }
      
      // 更新所有幻灯片数组
      allSlides = Array.from(track.querySelectorAll('.cover-slide, .slide-clone'));
      
      // 设置初始位置（显示原始的第一个幻灯片）
      const initialOffset = -slideWidth * cloneCount;
      scrollLeft = initialOffset;
      track.style.transform = `translateX(${scrollLeft}px)`;
      
      console.log(`🔄 初始化完成: 克隆 ${cloneCount} 个，初始偏移: ${initialOffset}px`);
      
      return { slideWidth, cloneCount };
    }
    
    // 初始化滚动
    initSeamlessScroll();
    
    // ========== 2. 自动滚动函数（真正无缝）- 修复移动端空白问题 ==========
    function startAutoScroll() {
      if (animationId) cancelAnimationFrame(animationId);
      
      function animate() {
        if (!isPaused && !isDragging && slideWidth > 0) {
          scrollLeft -= autoScrollSpeed;
          
          // 计算原始内容的宽度
          const originalContentWidth = slideWidth * totalSlides;
          const cloneContentWidth = slideWidth * cloneCount;
          
          // 当滚动超过原始内容+末尾克隆时，跳回到开头
          const maxScroll = -(originalContentWidth + cloneContentWidth);
          
          if (scrollLeft <= maxScroll) {
            // 无缝跳转：跳回到开头克隆的末尾位置
            scrollLeft = -cloneContentWidth;
            track.style.transition = 'none';
            track.style.transform = `translateX(${scrollLeft}px)`;
            // 强制重绘，避免视觉跳跃
            track.offsetHeight;
            track.style.transition = 'transform 0.5s ease';
            console.log('🔄 无缝跳转到开头');
          }
          
          track.style.transform = `translateX(${scrollLeft}px)`;
        }
        
        animationId = requestAnimationFrame(animate);
      }
      
      animate();
      console.log('🌀 自动滚动已启动');
    }
    
    // ========== 3. 鼠标拖动功能 ==========
function initDrag() {
  let dragStartX = 0;
  let dragStartScrollLeft = 0;
  
  track.addEventListener('mousedown', (e) => {
    isDragging = true;
    isPaused = true;
    if (animationId) cancelAnimationFrame(animationId);
    
    track.style.cursor = 'grabbing';
    track.style.transition = 'none';
    dragStartX = e.pageX;
    dragStartScrollLeft = scrollLeft;
    
    const onMouseMove = (e) => {
      if (!isDragging) return;
      e.preventDefault();
      
      const currentX = e.pageX;
      const distanceMoved = currentX - dragStartX;
      
      // 关键修复：去掉负号，改为加法
      // 这样：鼠标向右拖动 = distanceMoved为正 = scrollLeft增加 = translateX(正数) = 向右移动
      scrollLeft = dragStartScrollLeft + distanceMoved * 1.5;
      
      track.style.transform = `translateX(${scrollLeft}px)`;
    };
    
    const onMouseUp = () => {
      if (!isDragging) return;
      
      isDragging = false;
      track.style.cursor = 'grab';
      track.style.transition = 'transform 0.5s ease';
      
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
      
      setTimeout(() => {
        isPaused = false;
        startAutoScroll();
      }, 2000);
    };
    
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  });
  
  // 触摸屏支持
  track.addEventListener('touchstart', (e) => {
    isDragging = true;
    isPaused = true;
    if (animationId) cancelAnimationFrame(animationId);
    
    track.style.transition = 'none';
    dragStartX = e.touches[0].pageX;
    dragStartScrollLeft = scrollLeft;
    
    const onTouchMove = (e) => {
      if (!isDragging) return;
      e.preventDefault();
      
      const currentX = e.touches[0].pageX;
      const distanceMoved = currentX - dragStartX;
      
      // 同样的修复
      scrollLeft = dragStartScrollLeft + distanceMoved * 1.5;
      
      track.style.transform = `translateX(${scrollLeft}px)`;
    };
    
    const onTouchEnd = () => {
      if (!isDragging) return;
      
      isDragging = false;
      track.style.transition = 'transform 0.5s ease';
      
      checkBounds();
      
      setTimeout(() => {
        isPaused = false;
        startAutoScroll();
      }, 2000);
    };
    
    document.addEventListener('touchmove', onTouchMove);
    document.addEventListener('touchend', onTouchEnd);
  });
  
  track.style.cursor = 'grab';
}
    
    // ========== 检查边界，防止出现空白 ==========
    function checkBounds() {
      if (slideWidth <= 0) return;
      
      const originalContentWidth = slideWidth * totalSlides;
      const cloneContentWidth = slideWidth * cloneCount;
      const maxScroll = -(originalContentWidth + cloneContentWidth);
      const minScroll = -cloneContentWidth;
      
      // 如果超出边界，调整到合适位置
      if (scrollLeft < maxScroll) {
        scrollLeft = -cloneContentWidth;
        track.style.transform = `translateX(${scrollLeft}px)`;
      } else if (scrollLeft > minScroll) {
        scrollLeft = maxScroll + cloneContentWidth;
        track.style.transform = `translateX(${scrollLeft}px)`;
      }
    }
    
    // ========== 4. 箭头按钮功能 ==========
    function initArrowButtons() {
      if (leftArrow) {
        leftArrow.addEventListener('click', () => {
          console.log('⬅️ 向左滚动');
          isPaused = true;
          if (animationId) cancelAnimationFrame(animationId);
          
          // 每次滚动3个幻灯片的距离
          scrollLeft += slideWidth * 3;
          checkBounds();
          track.style.transform = `translateX(${scrollLeft}px)`;
          
          setTimeout(() => {
            isPaused = false;
            startAutoScroll();
          }, 2000);
        });
      }
      
      if (rightArrow) {
        rightArrow.addEventListener('click', () => {
          console.log('➡️ 向右滚动');
          isPaused = true;
          if (animationId) cancelAnimationFrame(animationId);
          
          // 每次滚动3个幻灯片的距离
          scrollLeft -= slideWidth * 3;
          checkBounds();
          track.style.transform = `translateX(${scrollLeft}px)`;
          
          setTimeout(() => {
            isPaused = false;
            startAutoScroll();
          }, 2000);
        });
      }
    }
    
    // ========== 5. 点击封面播放视频 ==========
    function initVideoClicks() {
      // 为所有幻灯片（包括克隆）添加点击事件
      allSlides.forEach((slide) => {
        slide.addEventListener('click', (e) => {
          if (isDragging) {
            console.log('⏸️ 拖动中，忽略点击');
            return;
          }
          
          // 直接从data-video-url属性获取视频链接
          const videoUrl = slide.getAttribute('data-video-url');
          
          console.log('🎬 点击视频，URL:', videoUrl);
          
          if (videoUrl && videoUrl !== 'null' && videoUrl !== '') {
            playVideo(videoUrl);
          } else {
            console.warn('⚠️ 视频链接为空或无效');
            alert('请先在Shopify后台设置视频链接');
          }
        });
      });
      
      // 检查所有视频链接
      slides.forEach((slide, index) => {
        const videoUrl = slide.getAttribute('data-video-url');
        console.log(`  视频 ${index + 1}: ${videoUrl ? '✅ 有链接' : '❌ 无链接'}`);
      });
    }
    
    // ========== 6. 视频播放器功能 ==========
    let videoModal = null;
    let playerVideo = null;
    let closeBtn = null;
    
    function initVideoPlayer() {
      videoModal = document.getElementById('video-player-modal');
      playerVideo = document.getElementById('player-video');
      closeBtn = document.getElementById('close-player');
      
      if (!videoModal || !playerVideo) {
        console.error('❌ 找不到播放器元素');
        return;
      }
      
      console.log('✅ 视频播放器已初始化');
      
      // 关闭按钮事件
      if (closeBtn) {
        closeBtn.addEventListener('click', closeVideoPlayer);
      }
      
      // 点击背景关闭
      const backdrop = document.getElementById('modal-backdrop');
      if (backdrop) {
        backdrop.addEventListener('click', closeVideoPlayer);
      }
      
      // ESC键关闭
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && videoModal.classList.contains('active')) {
          closeVideoPlayer();
        }
      });
    }
    
    function playVideo(url) {
      if (!videoModal || !playerVideo) {
        console.error('❌ 播放器未初始化');
        return;
      }
      
      console.log('▶️ 播放视频:', url);
      
      // 暂停自动滚动
      isPaused = true;
      if (animationId) cancelAnimationFrame(animationId);
      
      // 设置视频源
      playerVideo.src = url;
      
      // 显示播放器
      videoModal.classList.add('active');
      document.body.style.overflow = 'hidden';
      
      // 尝试播放（注意：现代浏览器可能阻止自动播放）
      playerVideo.play().then(() => {
        console.log('✅ 视频开始播放');
      }).catch(err => {
        console.log('⏸️ 需要用户点击播放按钮:', err.message);
        // 视频控件会显示，用户可以手动播放
      });
    }
    
    function closeVideoPlayer() {
      if (!videoModal || !playerVideo) return;
      
      playerVideo.pause();
      playerVideo.src = '';
      videoModal.classList.remove('active');
      document.body.style.overflow = '';
      
      // 恢复自动滚动
      setTimeout(() => {
        isPaused = false;
        startAutoScroll();
      }, 300);
      
      console.log('⏹️ 视频播放器已关闭');
    }
    
    // ========== 7. 悬停控制 ==========
    function initHoverControl() {
      container.addEventListener('mouseenter', () => {
        isPaused = true;
        if (animationId) cancelAnimationFrame(animationId);
        console.log('⏸️ 鼠标进入，暂停滚动');
      });
      
      container.addEventListener('mouseleave', () => {
        if (!isDragging) {
          isPaused = false;
          startAutoScroll();
          console.log('▶️ 鼠标离开，恢复滚动');
        }
      });
    }
    
    // ========== 8. 窗口大小变化重置 ==========
    function initResizeHandler() {
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          console.log('🔄 窗口大小变化，重新初始化滚动');
          
          // 停止当前动画
          if (animationId) {
            cancelAnimationFrame(animationId);
            animationId = null;
          }
          
          // 重新初始化
          const newData = initSeamlessScroll();
          slideWidth = newData.slideWidth;
          cloneCount = newData.cloneCount;
          scrollLeft = -slideWidth * cloneCount;
          
          // 重新开始自动滚动
          isPaused = false;
          startAutoScroll();
          
          console.log(`📱 移动端重置: slideWidth=${slideWidth}, cloneCount=${cloneCount}`);
        }, 250);
      });
    }
    
    // ========== 初始化所有功能 ==========
    initDrag();
    initArrowButtons();
    initVideoClicks();
    initHoverControl();
    initResizeHandler();
    initVideoPlayer();
    startAutoScroll();
    
    console.log('🎉 视频轮播初始化完成！');
    
    // ========== 调试命令 ==========
    window.debugVideo = {
      play: (index = 0) => {
        if (index >= 0 && index < slides.length) {
          const slide = slides[index];
          const videoUrl = slide.getAttribute('data-video-url');
          if (videoUrl) {
            playVideo(videoUrl);
          }
        }
      },
      pause: () => {
        isPaused = true;
        if (animationId) cancelAnimationFrame(animationId);
      },
      resume: () => {
        isPaused = false;
        startAutoScroll();
      },
      reset: () => {
        initSeamlessScroll();
        scrollLeft = -slideWidth * cloneCount;
        track.style.transform = `translateX(${scrollLeft}px)`;
        startAutoScroll();
      },
      getState: () => ({
        isPaused,
        isDragging,
        scrollLeft,
        slideWidth,
        totalSlides,
        cloneCount,
        containerWidth: container.clientWidth,
        trackWidth: track.scrollWidth
      })
    };
    
    console.log('🔧 调试命令可用: window.debugVideo');
  }
  
  // ========== 启动 ==========
  // 等待页面加载
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(initVideoCarousel, 500);
    });
  } else {
    setTimeout(initVideoCarousel, 1000);
  }
  
  // 错误处理
  window.addEventListener('error', (e) => {
    console.error('🚨 JavaScript错误:', e.message, 'at', e.filename, e.lineno);
  });
  
})();